/**
 * API 公共类型定义
 * 前台和后台共用的 API 响应格式和错误类
 */

/**
 * 标准 API 响应格式
 */
export interface ApiResponse<T = unknown> {
  error_code: number;
  message: string;
  data: T;
}

/**
 * 分页 API 响应格式
 */
export interface PaginatedApiResponse<T = unknown> extends ApiResponse<T> {
  meta: {
    total: number;
    page: number;
    limit: number;
  };
}

/**
 * API 错误类
 * 统一前后台的错误处理
 */
export class ApiError extends Error {
  code: number;
  status?: number;

  constructor(message: string, code: number = -1, status?: number) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.status = status;
  }
}
